import i18n from "../i18n";
import store from "../store";

export  default {
  getRiskColor(probability, consequenceLevel) {
    let riskValue = probability*consequenceLevel
    let riskMatrixType = store.getters.curRiskMatrixType
    let GREEN = "green base  text-center "
    let YELLOW = "yellow base  text-center"
    let ORANGE = "orange base  text-center"
    let RED = "red base text-center"

    if (riskMatrixType=="SJ_NORGE") {
      if (riskValue > 12)
        return RED
      else if (riskValue > 9)
        return ORANGE
      else if (riskValue > 4)
        return YELLOW
      else if (riskValue == 4) {
        if (probability == 2 ) {
          return GREEN
        } else {
          return YELLOW
        }
      } else
        return GREEN


    } else {
      if (riskValue > 12)
        return RED
      else if (riskValue > 8)
        return ORANGE
      else if (riskValue > 4)
        return YELLOW
      else
        return GREEN


    }

  },


  getBarrierTypes() {
    return  [{"id":"T", "name": i18n.t('barrierType.T')}
              ,{"id":"O", "name":i18n.t('barrierType.O')}
              ,{"id":"M", "name":i18n.t('barrierType.M')}]
  },


}
// {"id":"T", "name": i18n.t('barrierType.T')},{"id":"O", "name":i18n.t('barrierType.O')},{"id":"M", "name":i18n.t('barrierType.M')}
